import { Component, OnInit } from '@angular/core';
import { AuthService } from 'app/core/auth/_services/auth.service';

@Component({
	selector: 'kt-yeni-plaka',
	templateUrl: './yeni-plaka.component.html'
})
export class YeniPlakaComponent implements OnInit {
	plakaGoster = false;

	/**
	 * Component constructor
	 *
	 * @param authService: AuthService
	 */
	constructor(private authService: AuthService) {}

	ngOnInit(): void {
		if (localStorage.getItem('loginType') === 'plaka') {
			this.plakaGoster = true;
		} else {
			this.plakaGoster = false;
		}
	}

	redirectTo(): void {
		this.authService.logout();
	}
}
